module.exports = __webpack_public_path__ + "img/logo.76c17fc3.png";